<template>
    <div class="customer-overview-container">
        <div class="overview-entry">
            <label class="value salutation"><span class="salutation" v-if="salutation || title">{{ salutation?.displayname }} {{ title?.displayname}}</span></label>
            <label class="value name">{{ fullName }}</label>
        </div>
        <div class="overview-entry">
            <label class="value address">{{ fullStreet }}</label>
            <label class="value address">{{ fullCity }}</label>
            <label class="value address">{{ fullCountry }}</label>
        </div>
        <div class="overview-entry">
            <label class="value">{{ customer.email }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'customer-overview',
    inject: [ 'baseData' ],
    props: {
        customer: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    computed: {
        salutation() {
            return this.baseData.salutations.find(salutation => salutation.displayid === this.customer.salutationId)
        },
        title() {
            return this.baseData.titles.find(title => title.displayid === this.customer.titleId)
        },
        fullName() {
            return `${this.customer.firstName || ''} ${this.customer.lastName || ''}`
        },
        fullStreet() {
            return `${this.customer.street || ''} ${this.customer.houseNr || ''}${this.customer.houseNrInfo || ''}`
        },
        fullCity() {
            let customerdistrict = this.customer.district
            if (customerdistrict) {
                customerdistrict = ', ' + customerdistrict
            }
            return `${this.customer.zip || ''} ${this.customer.city|| ''}${customerdistrict || ''}`
        },
        fullCountry() {
            const country = this.baseData.countries.find(country => country.original === this.customer.countryId)

            return `${country?.displayname || ''}`
        }
    }
}
</script>

<style lang="scss" scoped>
.customer-overview-container {
    height: 100%;
    width: 100%;

    > .overview-entry {
        width: 100%;

        &:not(:first-child) {
            margin-top: 12px;
        }

        > label {
            display: block;
        }
        > .label {
            font-weight: bold;
        }

        > .value {
            margin-top: 4px;
            margin-left: 8px;
            
            // &.name {
            //     margin: 12px 8px;
            //     font-size: 1.5em;
            //     font-weight: bold;
            //     > .salutation {
            //         margin-right: 4px;
            //         font-size: 0.75em;
            //         font-weight: normal;
            //         color: #666;
            //     }
            // }

            // &.address {
            //     color: #666;
            // }
        }
    }
}
</style>